// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3DVQN","modalFooterButton":"ModalNotes_modalFooterButton__V-C4L"};